// Cookie names
export const COOKIE_SKIP_INTRO = "paidy_skip_intro";
export const COOKIE_SKIP_SIGNIN = "paidy_skip_signin";
export const COOKIE_EMAIL = "paidy_consumer_email";
export const COOKIE_PHONE = "paidy_consumer_phone";
export const COOKIE_REMEMBER = "paidy_consumer_remember";
export const COOKIE_OTP = "paidy_otp_timer";

// Environment checks
export const IS_PRODUCTION = process.env.ENVIRONMENT?.indexOf("production") >= 0;
export const IS_DEBUG_MODE = !IS_PRODUCTION;

// Payment statuses
export const PAYMENT_STATUS_MAP = {
  CREATED: "created",
  AUTHENTICATED: "authenticated",
  AUTHORIZED: "authorized",
  PENDING: "pending",
  REJECTED: "rejected",
  CLOSED: "closed",
  CANCELED: "canceled",
} as const satisfies Record<string, PaymentStatus>;
